// External Dependencies
import { useQuery } from '@tanstack/react-query';
import { EstimatesIndexRequest } from '@presto-assistant/api_types/api/admin/estimates';

// Internal Dependencies
import { prestoAdminApiClient } from 'utils/api/apiClient';

export const useGetAllEstimates = (queryParams: EstimatesIndexRequest['query']) => {
  return useQuery({
    queryFn: () => prestoAdminApiClient.v1.estimates.index({
      query: queryParams,
    }),
    queryKey: ['getAllEstimates', queryParams],
  });
};

export const useGetEstimate = (estimateId: string) => {
  return useQuery({
    queryFn: () =>
      prestoAdminApiClient.v1.estimates.show({ params: { estimateId } }),
    queryKey: ['getEstimate', estimateId],
  });
};
